import Autosuggest from 'react-autosuggest';
import React, { useState } from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { setInsightsCriteriaType } from '../../store/actions/criteria-actions';
import { isEmptyObject, escapeRegexCharacters } from '../../utilities/helpers';

const AutosuggestComponent = props => {
  const dispatch = useDispatch();
  const boundariesDataLoaded = useSelector(
    state => state.locations.boundariesDataLoaded
  );
  const boundariesDictionary = useSelector(
    state => state.locations.boundariesDictionary
  );
  const boundariesData = useSelector(state => state.locations.boundariesData);

  const reports = useSelector(state => state.client.reports);

  const [suggestions, setSuggestions] = useState([]);

  const [value, setValue] = useState('');
  const [selectedBoundaries, setSelectedBoundaries] = useState(props.data ? props.data : []);

  const setGeographyOptionArray = (reports, selectedReportIndex) => {
    // open all of tier in audience builder
    const showingTier = ["region","district", "city", "locality"]

    const tierArray = [
      {
        label: isEmptyObject(boundariesDictionary)
          ? 'New Zealand'
          : boundariesDictionary.country.name,
        value: 0,
        options: [
          {
            label:
              boundariesData[0] !== undefined &&
              boundariesData[0].options[0].label,
            level: 'adm0',
            value:
              boundariesData[0] !== undefined &&
              boundariesData[0].options[0].value,
          },
        ],
      },
    ];

    showingTier.forEach(item => {
      switch (item) {
        case 'district':
          tierArray.push({
            label: isEmptyObject(boundariesDictionary)
              ? 'District'
              : boundariesDictionary.district.name,
            value: 1,
            options:
              boundariesData[2] &&
              boundariesData[2].areas.map(item => ({
                label: `${item.name}, ${item.hierarchy.region}`,
                level: 'adm2',
                value: item.id,
              })),
          });
          break;
        case 'city':
          tierArray.push({
            label: isEmptyObject(boundariesDictionary)
              ? 'Major City'
              : boundariesDictionary.city.name,
            value: 2,
            options:
              boundariesData[3] &&
              boundariesData[3].areas.map(item => ({
                label: `${item.name}, ${item.hierarchy.region}`,
                level: 'adm3',
                value: item.id,
              })),
          });
          break;
        case 'locality':
          tierArray.push({
            label: isEmptyObject(boundariesDictionary)
              ? 'Suburb'
              : boundariesDictionary.locality.name,
            value: 3,
            options:
              boundariesData[4] &&
              boundariesData[4].areas.map(item => ({
                label: `${item.name}, ${item.hierarchy.place}`,
                level: 'adm4',
                value: item.id,
              })),
          });
          break;
        default:
          break;
      }
    });

    return tierArray;
  };

  const getSuggestions = value => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
      return [];
    }

    const regex = new RegExp(`^${escapedValue}`, 'i');

    return setGeographyOptionArray(reports, 0)
      .map(section => ({
        label: section.label,
        options: section.options.filter(index => regex.test(index.label)),
      }))
      .filter(section => section.options.length > 0);
  };

  const onSuggestionsFetchRequested = ({ value }) =>
    setSuggestions(getSuggestions(value));

  const onSuggestionsClearRequested = () => setSuggestions([]);

  const getSuggestionValue = suggestion => suggestion.label;

  const renderSuggestion = suggestion => <span>{suggestion.label}</span>;

  const renderSectionTitle = section => <strong>{section.label}</strong>;

  const getSectionSuggestions = section => section.options;

  const onChange = (event, { newValue, method }) => {
    dispatch(setInsightsCriteriaType('geography'));

    setValue(newValue);

    if (method === 'click') {
      setValue('');
    }
  };

  const onBlur = event => {
    setValue('');
  };

  const onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    const newArray = selectedBoundaries;

    const isDuplicate = newArray.some((item, idx) =>{
        return item.value === suggestion.value
    })
    if(isDuplicate === false) { newArray.push(suggestion); }

    setSelectedBoundaries(newArray);
    props.handleHomeChange(newArray)
  };

  const handleDelete = idx => {
    const newArray = selectedBoundaries.concat();
    newArray.splice(idx,1)
    setSelectedBoundaries(newArray);
    newArray.length === 0 ? props.handleHomeChange(null)  : props.handleHomeChange(newArray)
  };

  const inputProps = {
    placeholder:
      boundariesDataLoaded === false
        ? 'Loading...'
        : 'Type a geographical area',
    value,
    onChange,
    onBlur,
    disabled: boundariesDataLoaded === false,
  };

  const renderInputComponent = inputProps => (
    <div>
      <input {...inputProps} />
      <div style={{ paddingTop: '1rem' }}>
        {selectedBoundaries.map((item, idx) => (
          <div
            style={{
              display: 'inline-block',
              backgroundColor: '#E0E0E0',
              padding: '5px 15px',
              borderRadius: '30px',
              marginRight: '0.5rem',
              marginTop: '0.5rem',
            }}
          >
            <span>{item.label}</span>
            <IconButton onClick={() => handleDelete(idx)} size="small">
              <CancelIcon />
            </IconButton>
          </div>
        ))}
      </div>
    </div>
  );
  return (
    <Autosuggest
      multiSection
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderSectionTitle={renderSectionTitle}
      onSuggestionSelected={onSuggestionSelected}
      renderInputComponent={renderInputComponent}
      getSectionSuggestions={getSectionSuggestions}
      focusInputOnSuggestionClick
      inputProps={inputProps}
    />
  );
};

export default AutosuggestComponent;
